import React from "react";
import "./contact.css";

const Contact = () => {
    return (
        <div className={"contact"} id={"contact"}>
            <h1 className={"contact-title"}>Don't hesitate to contact me for
                any questions, opportunities and projects at </h1>
            <h1 className={"email"}>
                <a href={"mailto:mrigank.anand52@gmail.com"}>MRIGANK.ANAND@GMAIL.COM</a>
            </h1>
            <h1 className={"phone"}>
                <a href={"tel:+91-8287118974"}> +91-8287118974</a>
            </h1>
            <div className={"linkedin"}>
                <a href={"https://www.linkedin.com/in/mrigankanand/"} target={"_blank"}>
                    <i className="fab icon fa-linkedin linkedin-contact"></i>
                </a>
            </div>

        </div>
    );
}


export default Contact;